// extracted by mini-css-extract-plugin
export default {"ExternalUser":"styles_ExternalUser__Ctl9X","photo":"styles_photo__jqYzn"};